import $ from 'jquery';

class TourHandler{
    
    constructor(){
        if(document.getElementById("tour-listing-page")){
            this.getToursByCategory();
        }
    }

    getToursByCategory(){
        $('.tour-category').on('click', (e) => {
            let checkbox;
            if(e.currentTarget.tagName == 'A'){
                // enabled/ disabled the checkbox
                e.preventDefault();
                checkbox = $(e.currentTarget).siblings('.checkbox.tour-category');
                if(checkbox.prop('checked'))
                    checkbox.prop('checked', false);
                else checkbox.prop('checked', true);
            } else {
                checkbox = $(e.currentTarget);
            }
            let body = {"tourCategories" : []};

            const $checkboxes = $(e.currentTarget).closest('li').find('.checkbox.tour-category');
            if ($checkboxes.length > 0) {
                // Enabled / disabled all sub checkboxes
                if(checkbox.prop('checked')){
                    $checkboxes.prop('checked', true);
                } else {
                    $checkboxes.prop('checked', false);
                }
            }

            $('.checkbox.tour-category').each(function () {
                if ($(this).prop('checked')) {
                    body["tourCategories"].push({ "term_id": $(this).data('id') });
                }
            });

            if (body["tourCategories"]?.length === 0) {
                console.log("No valid category ID found.");
                $('#tour-listing-page').html(`<div class="col-md-12 section_title mb-3">
                    <h1>Please choose a destination to view tours.</h1><hr></div>`);
            } else {
                $.ajax({
                    url: sgttData.root_url + '/wp-json/sgtt/v1/tours',
                    method: "GET",
                    data: body,
                    success: (rs) => { 
                        // display the content result.
                        this.displayToursListingPage(rs.data);
                    },
                    error: (er) => {
                        console.log("ERRR: ");
                        console.log(er)
                    }
                });
            }

        });

    }

    displayToursListingPage(responseBody){

        $('#tour-listing-page').html("");
        let count = 0;
        $.each(responseBody, function (key, tourInfo) {
            let item =
                `<div class="col-md-12 section_title mb-3">
                    <hr>
                    <h1>${tourInfo['cate_name']}</h1>
                    <div>${tourInfo['cate_desc']}</div>
                </div>
                <!-- Swiper Container -->
                <div class="swiper my-tour-slider">
                    <div class="swiper-wrapper">
                `;

            
            $.each(tourInfo['tours'], function (index, tour) {
                item += `
                    <div class="mb-5 mb-lg-0 d-flex swiper-slide">
                        <article class="blog_item" >
                            <div class="card h-100">`;
                            if(tour.boost_label){
                                item += `<span class="badge sgtt-badge main-color">${tour.boost_label}</span>`;
                            }
                            if(tour.discount) {
                                item += `<span class="badge sgtt-badge-discount">${tour.discount.text}</span>`;
                            }
                            item+=`<div class="blog_item_img about_thumb">
                                    <a href="${tour.permalink}" >
                                        <img class="card-tour-img card-img rounded-0" src="${tour.thumbnail}" alt="${tour.name}" loading="lazy">
                                    </a>
                                    <div class="item_price">
                                        <p><i class="fa fa-clock-o"></i> ${tour.duration} hours</p>
                                        <p>`; 

                                        if(tour.allow_quotation){ 
                                            item +=`<i class="fa fa-usd"></i> Quote`;} 
                                        else {
                                            if(tour.discount){
                                                item += `<span class="discounted-price">${tour.discount.price_after_discount}</span>
                                                    <span class="original-price line-through">${tour.price_per_person}</span>`;
                                            } 
                                            else {
                                                item += `<span class="original-price">${tour.price_per_person}</span>`;
                                            }
                                        }

                                        item += `</p>

                                    </div>
                                </div>

                                <div class="blog_details tour_details h-100">
                                    <a class="d-inline-block" href="${tour.permalink}">
                                        <h2 class="h2_seo">${tour.name}</h2>
                                    </a>
                                    <p>${tour.excerpt}</p>
                                    
                                    <ul class="blog-info-link tour-review">`
                                    if(tour.amount_of_reviews){
                                        item += `
                                        <li>
                                            <a href="${tour.review_on_tripadvisor}" target="_blank">
                                            <b><i class="fa fa-tripadvisor"></i></b><svg class="tour-review-stars" viewBox="0 0 128 24" width="75" height="18" aria-label="5.0 of 5 bubbles" data-automation="reviewBubbles"><path d="M 12 0C5.388 0 0 5.388 0 12s5.388 12 12 12 12-5.38 12-12c0-6.612-5.38-12-12-12z" transform=""></path><path d="M 12 0C5.388 0 0 5.388 0 12s5.388 12 12 12 12-5.38 12-12c0-6.612-5.38-12-12-12z" transform="translate(26 0)"></path><path d="M 12 0C5.388 0 0 5.388 0 12s5.388 12 12 12 12-5.38 12-12c0-6.612-5.38-12-12-12z" transform="translate(52 0)"></path><path d="M 12 0C5.388 0 0 5.388 0 12s5.388 12 12 12 12-5.38 12-12c0-6.612-5.38-12-12-12z" transform="translate(78 0)"></path><path d="M 12 0C5.388 0 0 5.388 0 12s5.388 12 12 12 12-5.38 12-12c0-6.612-5.38-12-12-12z" transform="translate(104 0)"></path></svg>
                                            ${tour.amount_of_reviews} Reviews on Tripadvisor
                                            </a>
                                        </li>
                                        `
                                    }
                                    item +=`   
                                    </ul>
                                </div>
                            </div>
                        </article>
                    </div>
                `;
                                
            });
            item += `</div>
                    <!-- <div class="swiper-button swiper-button-prev"></div>
                        <div class="swiper-button swiper-button-next"></div> -->
                    <div class="swiper-pagination"></div>
                    </div>`;
            // Append the full slider block
            $('#tour-listing-page').append(item);

            // Initialize Swiper for this block
            setTimeout(() => {
                cardSlider('.my-tour-slider', 3);
            }, 50);

            // let $item = $(item); 
            // setTimeout(() => {
            //     $item.appendTo("#tour-listing-page").animate({ opacity: 1 }, 800);  
            //     if(tourInfo['tours'].length == (index+1)){
            //         $('#tour-listing-page').append();
            //         tourCardSlider();
            //     }
            // }, count * 500); // Delay increases for each item   
            // count++; 
            
        });
    }

}

export default TourHandler;